<template>
  <footer class="app-footer">
    <div class="footer-content">
      <div class="copyright"><span class="brand-name">鱼丁LEX AI</span> © {{ currentYear }} 法律辅助工具 · 合同智能审核平台</div>
      <div class="icp-info">
        <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
          京ICP备2025117993号-1
        </a>
      </div>
      <div class="disclaimer-text">本平台生成内容基于人工智能技术自动创建，请基于专业判断审慎使用。该内容不代表本平台立场。</div>
    </div>
  </footer>
</template>

<script>
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'AppFooter',
  setup() {
    const currentYear = computed(() => new Date().getFullYear())

    return {
      currentYear
    }
  }
})
</script>

<style scoped>
.app-footer {
  background: rgba(13, 13, 18, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding: 8px 0;
  text-align: center;
  border-top: 1px solid rgba(29, 147, 255, 0.1);
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  z-index: 10;
  width: 100%;
  margin-top: auto;
}

.app-footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(29, 147, 255, 0.3), transparent);
  animation: shimmer 3s infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}

.footer-content {
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  position: relative;
  z-index: 1;
}

.copyright {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
  position: relative;
  padding-bottom: 3px;
  text-shadow: 0 0 5px rgba(29, 147, 255, 0.2);
}

.brand-name {
  background: linear-gradient(90deg, rgba(29, 147, 255, 0.8), rgba(255, 255, 255, 0.7));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-weight: 500;
}

.copyright::after {
  content: '';
  position: absolute;
  width: 30px;
  height: 1px;
  background: rgba(29, 147, 255, 0.3);
  bottom: -1px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 1px;
}

.icp-info {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
  position: relative;
  padding-bottom: 3px;
}

.icp-info::after {
  content: '';
  position: absolute;
  width: 30px;
  height: 1px;
  background: rgba(29, 147, 255, 0.3);
  bottom: -1px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 1px;
}

.disclaimer-text {
  font-size: 8px;
  color: rgba(255, 255, 255, 0.4);
}
</style>
